import { VEC_ICON_NAME } from "../../../../../components/icons/constants"

export const PAYER_TYPE_TITLE = {
    INDIVIDUAL: "Individual",
    BUSINESS: "Business"
}

export const PAYER_TYPE = [
    { title: PAYER_TYPE_TITLE.INDIVIDUAL, icon: VEC_ICON_NAME.PAYER_TYPE_INDIVIDUAL },
    { title: PAYER_TYPE_TITLE.BUSINESS, icon: VEC_ICON_NAME.PAYER_TYPE_BUSINESS }
]

export const PAYER_TYPE_1042_S_TITLES = {
    EIN: "EIN",
    QI_WP_WT_EIN: "QI-EIN, WP-EIN, WT-EIN",
    NQI_EIN: "NQI-EIN",
}

export const PAYER_TYPE_1042_S = [
    { title: PAYER_TYPE_1042_S_TITLES.EIN, icon: VEC_ICON_NAME.PAYER_TYPE_INDIVIDUAL, value: "EIN" },
    { title: PAYER_TYPE_1042_S_TITLES.QI_WP_WT_EIN, icon: VEC_ICON_NAME.PAYER_TYPE_INDIVIDUAL, value: "QI-EIN" },
    { title: PAYER_TYPE_1042_S_TITLES.NQI_EIN, icon: VEC_ICON_NAME.PAYER_TYPE_INDIVIDUAL, value: "NQI-EIN" },
];

export const PAYER_ID_TYPE = {
    EIN: "EIN",
    SSN: "SSN",
}
